'use client';

import { useTranslations } from 'next-intl';

import { cn } from '@/lib/utils';

interface WhatsAppLinkProps {
  children: React.ReactNode;
  className?: string;
  ariaLabel?: string;
}

/**
 * WhatsApp link via API redirect - phone number never appears in client HTML.
 */
export function WhatsAppLink({ children, className, ariaLabel }: WhatsAppLinkProps) {
  const t = useTranslations('common.phoneReveal');

  return (
    <a
      href='/api/contact/whatsapp'
      target='_blank'
      rel='noopener noreferrer'
      className={cn(className)}
      aria-label={ariaLabel ?? t('whatsAppLabel')}
    >
      {children}
    </a>
  );
}
